import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { resetColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getReset } from "../../../../api/sim";

const COPY_KEYS = ["id", "batch_id", "iccid", "status", "last_updated"];

const ResetBatch = () => (
  <BatchDetail
    title="Reset"
    apiGet={__getReset}
    client={CLIENTS.pwg}
    columnsFactory={(ctx) => resetColumns({ ...ctx, iccidHeaderName: "MDN" })}
    copyKeys={COPY_KEYS}
    exportAction="reset"
    retryOperation="reset"
    showTerminate
    getRowPath={(row) => `/pwg/reset/${row.id}`}
  />
);

export default ResetBatch;
